import React from 'react';
import { Formik } from 'formik';
import { LoginForm } from 'stash/components/log-in/LogInComponents';
import { PasswordBox } from 'stash/components/global/PasswordYupInput';
import * as validations from 'stash/utils/formValidations';
import * as Yup from 'yup';
import {
	Text,
	PrimaryButton,
	Link,
	SmartLink,
	Box,
	FormikTextInput,
} from '@stashinvest/ui';
import NudataSDK from 'stash/components/nudata';
import useNudata from 'stash/hooks/nudata';
import { isIos, isAndroid } from 'stash/utils';

const ResetInitialValues = {
	password: '',
	confirmPassword: '',
};

const ResetValidationSchema = Yup.object().shape({
	password: validations.yupPasswordValidation(),
	confirmPassword: Yup.string()
		.oneOf([Yup.ref('password'), null], 'Passwords must match')
		.required('Password confirm is required'),
});

const ResetPasswordForm = (props) => {
	const { nudataSession } = useNudata();
	const isMobileDevice = isIos() || isAndroid();
	const nudataPlacement = {
		name: isMobileDevice ? 'PasswordResetMobile' : 'PasswordResetWeb',
		page: 2,
	};

	return (
		<Formik
			initialValues={ResetInitialValues}
			validationSchema={ResetValidationSchema}
			onSubmit={(values, actions) => {
				props.onSubmit(values, nudataSession, nudataPlacement).catch((resp) => {
					actions.setFieldError('password', resp.message);
					actions.setSubmitting(false);
				});
			}}
		>
			{(formProps) => (
				<LoginForm>
					<Text.H1 size={3} mb="m">
						Reset Password
					</Text.H1>
					<Box mb="l">
						<PasswordBox
							name="password"
							label="Create a new password"
							autoFocus={true}
							{...formProps}
						/>
					</Box>
					<Box mb="l">
						<FormikTextInput
							name="confirmPassword"
							placeholder="password"
							label="Confirm Password"
							type="password"
							{...formProps}
						/>
					</Box>
					<Box mb="l">
						<PrimaryButton type="submit" loading={formProps.isSubmitting}>
							Submit
						</PrimaryButton>
					</Box>
					<Box mb="l">
						<Link
							as={SmartLink}
							href="https://ask.stash.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Need help?
						</Link>
					</Box>
					<NudataSDK
						placementName={nudataPlacement.name}
						placementPage={nudataPlacement.page}
					/>
				</LoginForm>
			)}
		</Formik>
	);
};

export default ResetPasswordForm;
